
/** 导航轨迹点 */
export interface Point {
    lat: number;
    lng: number;
}

/** 停靠点（出参，含起 -1 / 终 -2；stopNo 为顺序号） */
export interface ReplayStop {
    stop: string;
    stopNo?: number | null;
    streetAddress?: string | null;
    unit?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    latitude: number;
    longitude: number;
}

/** 停靠点（入参，前端按目标顺序拼好，含起 -1 / 终 -2） */
export interface ReplayStopInput {
    stop: string;
    streetAddress?: string | null;
    unit?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
    county?: string | null;
    latitude: number;
    longitude: number;
}

/** 5 个指标（扁平，与算法 NavigationRouteResultDTO 同名） */
export interface ReplayMetricsFields {
    totalDistanceKm?: number | null;
    totalDurationMinutes?: number | null;
    leftTurnCount?: number | null;
    uTurnCount?: number | null;
    trafficLightCount?: number | null;
}

/** 停靠点 selection set 片段 */
export const REPLAY_STOP_FIELDS = `
    stop
    stopNo
    streetAddress
    unit
    city
    state
    zipCode
    county
    latitude
    longitude
`;
